<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Product
            </template>
            <template v-slot:pageDetail>
                List
            </template>
            <template v-slot:pageDescription>
               
                <br>
               
            </template>
        </o-bread-crumb>
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>

        <!-- Feature Disabled State -->
        <div v-if="!isMerchantProductEnabled" class="feature-disabled-container mt-4">
            <div class="disabled-content">
                <i class="fas fa-toggle-off fa-3x primary-text mb-3"></i>
                <h4>Product Management Disabled</h4>
                <p>The Product Management feature has been disabled by System Administration. Please contact System Owner to enable this feature.</p>
            </div>
        </div>

        <template v-if="isMerchantProductEnabled">
        <div v-if="thisComponentShow" class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">List of Products</a>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm" v-if="write">
                        <router-link :to="{ name: 'ProductForm' }" class="nav-link text-white">Add new product
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="" v-if="page.output">
                <div class="d-flex d-inline-block">
                    <div class="form-group" v-if="selectedBusinessProfile.merchant_id == '' || selectedBusinessProfile.merchant_id == null">
                        <label for="">Merchant id</label>
                        <o-select v-model="selectMerchant" :options="merchants" autocomplete="'off'"></o-select>
                    </div>
                </div>
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">                                
                            <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm">
                        <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                    </li>
                </ul>
                <o-table style="text-align:left;" class="table-hover">
                    <thead>
                        <tr>
                            <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="(item, index) in products" :key="index">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div>{{ item.id.slice(0, 9) + '...' }}</div>
                                    <button class="btn btn-sm btn-secondary ms-2" @click="copyToClipboard(item.id)">Copy</button>
                                </div>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</td>
                            <td>
                                <span class="badge-source rounded-pill">
                                    {{ item.source || 'Membership' }}
                                </span>
                            </td>
                            <td class="ml-3">
                                <div class="d-flex">
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-info rounded-pill text-white" v-if="write">
                                            <router-link class="text-white" :to="{ name: 'ProductEdit', params: { id: item.id } }">Edit
                                            </router-link>
                                        </button>
                                    </div>
                                    <div>
                                        <button class="btn btn-sm btn-danger rounded-pill text-white" v-if="write" @click.prevent="confirmDelete(item)">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="products.length === 0">
                            <td colspan="6" class="text-center">No products available</td>
                        </tr>
                    </tbody>
                </o-table>
            </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        <o-warning-box
            v-if="isDeleteConfirmVisible"
            title="Delete Product"
            :item-name="itemToDelete?.name || 'this product'"
            warning-message="This action cannot be undone."
            confirm-text="Yes, Delete"
            cancel-text="Cancel"
            :is-loading="page.isLoading"
            @confirm="handleDelete"
            @cancel="closeDeleteConfirm"
        />
        </template>
    </div>
    <br>

</template>

<script>
import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OSelect, OSearch, OWarningBox} from '@/components/OmnihControl'
import { computed, onMounted, reactive, ref, watch, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSelect,
        OSearch,
        OWarningBox
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const vuexStore = useStore();
        let lastActivePage = 1;

        const isMerchantProductEnabled = computed(() => {
            const flag = vuexStore.getters['FeatureFlag/getMerchantProductFlag'];
            return flag !== 'NONACTIVE';
        });

        let meta = computed(() => store.state.Product.meta)

        // let items = ref([]);
        let page = reactive({
            isLoading: false,
            output: false,
            component: 'product'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        let fields = ref([
            'No',
            'ID',
            'Name',
            'Price',
            'Source',
            'Action',
        ]);

        const productSearch = ref([]);
        const validation = ref('');

        const selectProduct = ref();

        const searchBy = reactive({
            selected:"code",
            criteria:"",
            date_start: "",
            date_end: ""
        })

        const searchOptions = reactive([
            { value: 'name', text: 'name' }
        ])

        const merchants = ref([]);

        const selectMerchant = ref();

        const selectedBusinessProfile = reactive({
            branch_id: '',
            merchant_id: ''
        });

        const thisComponentShow = ref(true);

        const write = ref(false);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            store.commit('Product/reset_meta');

            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }

            // Check if redirected from create product page
            if (route.query.newProduct === 'true') {
                store.dispatch('Product/read').then(() => {
                    const lastPage = meta.value.total;
                    if (lastPage > 1 && meta.value.page !== lastPage) {
                        const newMeta = { ...meta.value, page: lastPage };
                        store.commit('Product/switch_page', { meta: newMeta });
                        store.dispatch('Product/read');
                    }
                    router.replace({ name: 'Product' });
                });
            }
        });

        onBeforeUnmount(() => {
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Product/switch_page', { meta: updatedMeta });

            store.commit('Product/clear_search');
            store.dispatch('Product/read').then(() => {});
        });

        function copyToClipboard(text) {
            navigator.clipboard.writeText(text)
                .then(() => {                    
                    alert('ID success to copied!');
                })
                .catch(err => {                    
                    console.error('Cannot copied ID: ', err);
                });
        }

        function load_state(){
            page.isLoading = true;

            // Set write permission first
            if (store.state.Auth.currUser.level === 'root') {
                write.value = true;
            } else {
                const userModules = store.state.Auth.userInfo.modules;

                if (userModules) {
                    const matchingModule = userModules.find(module => module.module_name === page.component);
                    write.value = matchingModule ? matchingModule.write : false;
                } else {
                    console.error('userModules is undefined');
                    write.value = false;
                }
            }

            const filter = selectMerchant.value == "all" ? { branch_id: selectedBusinessProfile.branch_id } : { merchant_id: selectMerchant.value };

            store.commit('Product/add_filter', {filter});
            return store.dispatch('Product/read')
            .then(function(){
                })
            .catch((err) => {
                validation.value = err;
                console.error(err);
            })
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });
        }

        const isDeleteConfirmVisible = ref(false)
        const itemToDelete = ref(null)

        const confirmDelete = (item) => {
            itemToDelete.value = item
            isDeleteConfirmVisible.value = true
        }

        const closeDeleteConfirm = () => {
            isDeleteConfirmVisible.value = false
            itemToDelete.value = null
        }

        const handleDelete = () => {
            if (!itemToDelete.value) return

            page.isLoading = true

            store.dispatch('Product/delete', itemToDelete.value.id)
            .then(() => {
                store.dispatch('Product/read')
                .then(function(){
                    })
                .catch((err) => console.error(err));
            }).catch((err) => {
                console.log(err);
                validation.value = err.message;
            }).finally(() => {
                page.isLoading = false;
                closeDeleteConfirm();
            });
        }

        function formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            console.log({page});
            console.log({_meta});
            store.commit('Product/switch_page',{meta:_meta})
            load_state()
        }

        async function loadSelectedBusinessProfile() {
            const shouldRedirectToLastPage = route.query.newProduct === 'true';
            
            // Remove query parameter first to prevent re-triggering
            if (shouldRedirectToLastPage) {
                await router.replace({ name: 'Product' });
            }
            
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.branch_id = businessProfile.branch_id;
                selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                selectMerchant.value = !businessProfile.merchant_id ? "all" : businessProfile.merchant_id;

                if (!businessProfile.merchant_id) {
                    loadMerchants();
                }
            }).finally(async () => {
                await load_state();
                
                // Redirect to last page if needed
                if (shouldRedirectToLastPage) {
                    goToLastPage();
                }
            });
        }

        function goToLastPage() {
            const lastPage = meta.value.total;
            console.log('goToLastPage called, lastPage:', lastPage, 'currentPage:', meta.value.page);
            if (lastPage > 1 && meta.value.page !== lastPage) {
                const newMeta = { ...meta.value, page: lastPage };
                store.commit('Product/switch_page', { meta: newMeta });
                load_state();
            }
        }

        function loadMerchants() {
            const filter = {
                branch_id: selectedBusinessProfile.branch_id,
            }

            store.commit('Merchant/add_filter', {filter});
            store.dispatch('Merchant/read').then(() => {
                merchants.value = [{value: "all", text: "From all merchant"}, ...store.state.Merchant.merchants.map((merch)=>({'value':merch.id,'text':merch.name}))]
            })
        }

        function search(searchBy){
            const {selected, criteria, date_start, date_end} = searchBy;

            if (selected) {
                let search = {}

                if (criteria && selected !== 'created_at'){
                    search[selected] = criteria;
                }else if(date_start && date_end){
                    search[selected] = `${date_start}, ${date_end}`;
                }

                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Product/switch_page', { meta: updatedMeta });

                store.commit('Product/set_search', {search});
                store.dispatch('Product/read').then(() => {});
            }

        }

        function clearSearch(){
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Product/switch_page', { meta: updatedMeta });

            store.commit('Product/clear_search');
            store.dispatch('Product/read').then(() => {});
        }

        watch(
            () => selectMerchant.value,
            (newVal) => {
                const filter = newVal == "all" ? { branch_id: selectedBusinessProfile.branch_id } : { merchant_id: newVal }

                store.commit('Product/add_filter', {filter});
                store.dispatch('Product/read')
                .then()
                .catch((err) => {
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                    console.error(err);
                })
                .finally(() => page.output = true);
            }
        )

        return {
            page,
            confirmDelete,
            handleDelete,
            closeDeleteConfirm,
            isDeleteConfirmVisible,
            itemToDelete,
            fields,
            formatPrice,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            selectProduct,
            productSearch,
            searchBy,
            searchOptions,
            search,
            clearSearch,
            copyToClipboard,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            isMerchantProductEnabled
        }
    },
    computed: {
        ... mapState({
            // arrow functions can make the code very succinct!
            products: state => state.Product.products,
            searchBy: state => state.Product.search
        }),
    },
}
</script>

<style scoped>
    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }

    /* Feature Disabled State */
    .feature-disabled-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        padding: 2rem;
    }

    .disabled-content {
        text-align: center;
        color: #6b7280;
    }

    .disabled-content h4 {
        color: #374151;
        margin-bottom: 0.5rem;
        font-weight: 600;
    }

    .disabled-content p {
        margin: 0;
        font-size: 0.95rem;
    }

    .badge-source {
        background-color: var(--secondary-color);
        color: var(--primary-color);
        padding: 0.25em 0.75em;
        font-size: 0.75rem;
    }
</style>